module.exports = __webpack_public_path__ + "static/media/carousel_eggs_4.579d1c17.jpg";